import React from 'react';
import { useSettings } from '../contexts/SettingsContext';
import { useLanguage } from '../contexts/LanguageContext';

export const AboutSection = () => {
  const { settings } = useSettings();
  const { t, getBilingualValue } = useLanguage();
  
  return (
    <section id="about" className="bg-gray-50 py-20">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-gray-900 mb-12">
          {getBilingualValue(settings.about?.title, 'about.title')}
        </h2>
        <div className="grid md:grid-cols-3 gap-10 max-w-5xl mx-auto">
          <div className="p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="text-5xl font-bold mb-4" style={{ color: settings.colors?.primary || '#0E7A5F' }}>1</div>
            <h3 className="text-2xl font-bold mb-4">
              {getBilingualValue(settings.about?.card1?.title, 'about.connect')}
            </h3>
            <p className="text-gray-600 leading-relaxed">
              {getBilingualValue(settings.about?.card1?.description, 'about.connectDesc')}
            </p>
          </div>
          <div className="p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="text-5xl font-bold mb-4" style={{ color: settings.colors?.primary || '#0E7A5F' }}>2</div>
            <h3 className="text-2xl font-bold mb-4">
              {getBilingualValue(settings.about?.card2?.title, 'about.showcase')}
            </h3>
            <p className="text-gray-600 leading-relaxed">
              {getBilingualValue(settings.about?.card2?.description, 'about.showcaseDesc')}
            </p>
          </div>
          <div className="p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="text-5xl font-bold mb-4" style={{ color: settings.colors?.primary || '#0E7A5F' }}>3</div>
            <h3 className="text-2xl font-bold mb-4">
              {getBilingualValue(settings.about?.card3?.title, 'about.scale')}
            </h3>
            <p className="text-gray-600 leading-relaxed">
              {getBilingualValue(settings.about?.card3?.description, 'about.scaleDesc')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
